"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useSite } from "@/contexts/site/site.context";
import type { DomId } from "@/vendors/GoogleTag/config/ad-slots.config";
import { useAdSlot } from "@/vendors/GoogleTag/hooks/use-ad-slot.hook";
type AdSlotProps = {
  readonly domId: DomId;
  readonly className?: string;
  readonly onBeforeShow?: (isEmpty: boolean) => void;
};
export function AdSlot(t0) {
  const $ = _c(13);
  const {
    className,
    domId,
    onBeforeShow
  } = t0;
  const {
    locale
  } = useSite();
  let t1;
  if ($[0] !== domId || $[1] !== onBeforeShow) {
    t1 = {
      domId,
      onBeforeShow
    };
    $[0] = domId;
    $[1] = onBeforeShow;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    isAdEmpty
  } = useAdSlot(t1);
  const t2 = isAdEmpty && "hidden";
  let t3;
  if ($[3] !== className || $[4] !== t2) {
    t3 = clsx("relative mx-auto bg-whisper print:hidden", "opacity-100 before:absolute before:-top-2 before:left-0 before:select-none before:text-dim before:text-xs before:uppercase before:leading-none before:tracking-label before:content-[attr(data-label)]", t2, className);
    $[3] = className;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      da: "Annonce",
      de: "Anzeige",
      en: "Advertisement",
      no: "Annonse",
      sv: "Annons"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = t4[locale];
  const t6 = `google-ad-slot-${domId}`;
  let t7;
  if ($[7] !== domId || $[8] !== isAdEmpty || $[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <aside aria-hidden={isAdEmpty} className={t3} data-label={t5} data-testid={t6} hidden={isAdEmpty} id={domId} />;
    $[7] = domId;
    $[8] = isAdEmpty;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}